export const sendCustomEvent = data => {
  if (window.apmPlus) {
    window.apmPlus('sendEvent', data);
  }
};
